import React from "react";
import { DD_MM_YYYY } from "src/helpers";

interface ModelFooterSectionProps {
  createdAt?: string;
  updatedAt?: string;
}

const ModelFooterSection: React.FC<ModelFooterSectionProps> = ({ createdAt, updatedAt }) => (
  <div className="mt-9 pt-4 border-t border-gray-200 text-sm text-gray-500">
    <div>
      Date Created: {createdAt && DD_MM_YYYY.formatDate(new Date(createdAt))}
      {updatedAt && <>&nbsp;&nbsp;|&nbsp;&nbsp;Date Updated: {DD_MM_YYYY.formatDate(new Date(updatedAt))}</>}
    </div>
  </div>
);

export { ModelFooterSection };
